import { useState } from 'react';

const FAQBeach = () => {
    const faqs = [
        {
          question: "What are the best beaches in the world?",
          answer: "Ah, the eternal question!  It's tough to narrow it down, as 'best' is subjective, but some consistently top-rated beaches include Whitehaven Beach in Australia (that silica sand!),  Grace Bay Beach in Turks and Caicos,  El Nido in the Philippines, and the pink sands of Elafonisi Beach in Greece.  But honestly, the best beach is the one that makes you happy, whether it's a secluded cove, a surfer's paradise, or a lively stretch with beach bars and water sports."
        },
        {
          question: "What should I pack for a beach holiday?",
          answer: "Swimsuits (plural!),  a beach bag, a quick-drying towel, sunscreen (lots of it!), sunglasses, a hat, and a good book.  Don't forget a cover-up or sarong for those breezy evenings and a reusable water bottle to stay hydrated.  Oh, and maybe a waterproof phone case for those underwater selfies!"
        },
        {
          question: "What are some fun activities to do on a beach holiday besides swimming and sunbathing?",
          answer: "The possibilities are endless!  Try snorkeling or diving to explore the underwater world, build epic sandcastles with the kids, go for a romantic stroll at sunset, learn to surf, try stand-up paddleboarding, or even take a boat trip to explore nearby islands or coves."
        },
        {
          question: "How can I find affordable beach holidays?",
          answer: "Travel during the shoulder seasons (spring or fall) for lower prices and fewer crowds.  Consider destinations that are known for being budget-friendly, like Thailand, Portugal, or Mexico.  Look for all-inclusive packages that bundle your flights, accommodations, and meals.  And don't forget to check out Halo Holidays' deals page for some amazing discounts!"
        },
        {
          question: "What are some tips for making the most of my beach holiday?",
          answer: "Embrace the relaxed island vibes and let go of any strict schedules.  Disconnect from technology and reconnect with nature and your loved ones.  Try new activities, savor local cuisine, and soak up the beauty of your surroundings.  And most importantly, don't forget to relax and have fun!"
        }
      ];
      

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="mt-8 px-4 md:px-0">
      <h2 className="text-2xl font-semibold mb-4">FAQs</h2>
      {faqs.map((faq, index) => (
        <div key={index} className="mb-4 lg:w-[900px]">
          <div
            className={`cursor-pointer py-4 px-4 bg-white rounded-lg shadow-sm border border-light hover:shadow-md transition-shadow ${activeIndex === index ? 'pb-8' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            <div className="flex justify-between items-center">
              <h3 className="text-base md:text-lg font-medium w-[90%]">{faq.question}</h3>
              <svg
                className={`w-8 h-8 transition-transform duration-300 p-1 rounded-full text-halo-pink hover:bg-halo-pink hover:text-white focus:outline-none ${activeIndex === index ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            {activeIndex === index && (
              <p className="mt-3 text-gray-700">{faq.answer}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQBeach;
